module.exports = __webpack_public_path__ + "img/chaBing4.8cc26003.png";